import { defineFcm } from '../shared/factory';

export const FCM_CORGI_SSR_TIMINGS_RESPONSE_HEADER = defineFcm('corgi_ssr_timings_response_header')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'Corgi SSR',
		description: `If enabled, and trace request header is sent, page HTTP response will contain a X-Change-SSR-Timings header with timing information.

		Make sure to only enable this in production temporarily if needed for debugging/investigation.`,
	});
